// extracted by mini-css-extract-plugin
export default {"Button":"project-error-fallback-module__Button--E95nA"};